
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectCheckRuleTypeEnum } from '../models/work-project-check-rule-type-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkProjectCheckStatusEnum } from '../models/work-project-check-status-enum';
import { WorkProjectCheckRuleApplicableBlockTypeEnum } from '../models/work-project-check-rule-applicable-block-type-enum';

export function getCreateProjectCheckRuleDtoFormGroup() {
return new FormGroup({
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    identifier: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    ruleType: new FormControl<WorkProjectCheckRuleTypeEnum | undefined>(undefined, [Validators.required]),
    enabled: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    sortOrder: new FormControl<number | undefined>(undefined, [Validators.required]),
    activeFromWeeksBeforeInstallation: new FormControl<number | undefined>(undefined),
    activeFromDate: new FormControl<string | undefined>(undefined),
    config: new FormControl<any | undefined>(undefined, [Validators.required]),
    messageOk: new FormControl<string | undefined>(undefined),
    messageWarning: new FormControl<string | undefined>(undefined),
    messageProblem: new FormControl<string | undefined>(undefined),
    messageNone: new FormControl<string | undefined>(undefined),
    statusWhenInactive: new FormControl<WorkProjectCheckStatusEnum | undefined>(undefined),
    applicableBlockTypes: new FormControl<WorkProjectCheckRuleApplicableBlockTypeEnum | undefined>(undefined, [Validators.required]),
    applicableTaskStandardtaskIds: new FormControl<Array<number> | undefined>([]),
    visibleInMontageplan: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    visibleForCustomer: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    customerLabel: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    customerMessageOk: new FormControl<string | undefined>(undefined),
    customerMessageWarning: new FormControl<string | undefined>(undefined),
    customerMessageProblem: new FormControl<string | undefined>(undefined),
})
;
}
      